declare let jQuery: any;
declare let jcf: any;
export class JcfManager {
  public extracted() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  public reloadJcf() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();

      jcf.destroy(jQuery.find('ng-select2 > select'));
      jcf.destroy(jQuery.find('#chk1'));
      jQuery(jQuery.find('ng-select2 > select')).addClass('jcf-ignore');
      jQuery(jQuery.find('#chk1')).addClass('jcf-ignore');
      jcf.refresh(document.getElementsByTagName('ng-select2')[0]);
      jcf.refresh(document.getElementById('#chk1')[0]);
    });
  }
}
